<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <form-wizard
    color="rgba(var(--vs-primary), 1)"
    :title="null"
    :subtitle="null"
    nextButtonText="Save & Continue"
    backButtonText
    finishButtonText="NEXT"
    @on-complete="onComplete"
    v-if="EventData"
    class="eventaddclass"
  >
    <tab-content
      title="Event profile"
      class="mb-2"
      :before-change="before_save"
    >
    <p>Rossuvellus</p>
      <!-- tab 1 content -->
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full md:mt-2 name-evnt">
          <vs-input
            class="w-full"
            label="Event Name"
            v-validate="'required'"
            name="Event Full Name"
            v-model="EventData.EventFullName"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('Event Full Name')"
            >{{ errors.first("Event Full Name") }}</span
          >
        </div>
        <div class="vx-col sm:w-1/2 w-full md:mt-2">
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full evnt-date">
              <label class="type-evnt-lbl">Event Start Date</label>
              <flat-pickr
                :config="configdateTimePickerStart"
                class="time-pkr"
                placeholder="Start Date"
                v-validate="'required'"
                name="Event Start Date"
                v-model="EventData.EventStartDate"
              ></flat-pickr>
              <span
                class="text-danger text-sm"
                v-show="errors.has('Event Start Date')"
                >{{ errors.first("Event Start Date") }}</span
              >
            </div>
            <div class="vx-col sm:w-1/2 w-full evnt-date">
              <label class="type-evnt-lbl">Event End Date</label>
              <flat-pickr
                :config="configdateTimePickerEnd"
                class="time-pkr"
                placeholder="End Date"
                v-validate="'required'"
                name="Event End Date"
                v-model="EventData.EventEndDate"

              ></flat-pickr>
              <span
                class="text-danger text-sm"
                v-show="errors.has('Event End Date')"
                >{{ errors.first("Event End Date") }}</span
              >
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-6/12 w-full mt-4">
          <vs-select
            v-model="EventData.TimeZone"
            class="w-full select-large"
            label="Time Zone"
            :options="tzStrings"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.label"
              v-for="(item, index) in tzStrings"
              class="w-full"
            />
          </vs-select>
        </div>
        <div class="vx-col sm:w-3/12 w-full mt-4">
          <label class="type-evnt-lbl labl-head">
            <span>Event Access</span>
            <span class="event-access-info">
              <feather-icon class="ml-2" icon="InfoIcon" title />
              <div class="event-type-head-tooltip-event-create">
                <p class="mb-0">
                  <strong>Public:</strong>
                </p>
                <p>
                  Anyone can discover and register for a Public event (they will
                  be indexed by search engines).
                </p>
                <p class="mb-0">
                  <strong>Private:</strong>
                </p>
                <p>
                  Events which do not require self registration. Event planners
                  send invitation and login info to join the event.
                </p>
              </div>
            </span>
          </label>
          <div class="w-full mt-2">
            <vs-radio v-model="EventData.EventType" vs-value="2"
              >Public</vs-radio
            >
            <vs-radio class="ml-3" v-model="EventData.EventType" vs-value="1"
              >Private</vs-radio
            >
          </div>
        </div>
        <div
          class="vx-col sm:w-3/12 w-full mt-4"
          v-show="EventData.EventType == 2"
        >
          <div class="type-evnt-create">
            <!--<label class="type-evnt-lbl">Allow Registration</label>-->
            <div class="w-full mt-2">
              <vs-checkbox v-model="EventData.AllowRegistration"
                >Allow Registration</vs-checkbox
              >
            </div>
          </div>
        </div>

        <div class="vx-col sm:w-6/12 w-full mt-4">
          <label>
            <span>Login Authentication</span>
          </label>
          <div class="w-full mt-2">
            <v-select
              class="w-full select-large"
              v-model="EventData.EventAccessType"
              :options="[
                'Unique Passcode per Attendee',
                'Use Common Event Passcode',
              ]"
            />
          </div>
        </div>
        <div
          class="vx-col sm:w-6/12 w-full mt-4"
          v-show="ClientDetails && ClientDetails.crm_integration && ClientDetails.crm_integration.IsPublished"
        >
          <label>CRM Integration</label>
          <vs-switch
            class="mt-4"
            @change="checkCRMDisable"
            v-model="EventData.postToCRM"
          />
        </div>
        <div
          class="vx-col sm:w-3/12 w-full mt-4"
          v-show="EventData.EventAccessType == 'Use Common Event Passcode'"
        >
          <div class="w-full mt-2">
            <vs-input
              label="Default Passcode"
              name="Default Passcode"
              v-model="EventData.defaultEP"
              v-validate="
                EventData.EventAccessType == 'Use Common Event Passcode'
                  ? 'required'
                  : ''
              "
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('Default Passcode')"
              >{{ errors.first("Default Passcode") }}</span
            >
          </div>
        </div>
        <div class="vx-col sm:w-3/12 w-full mt-4">
          <label>Default Streaming Client</label>
          <div class="w-full mt-5">
            <vs-radio
              v-model="EventData.StreamingClient"
              vs-value="Web"
              name="StreamingClient"
              >Web</vs-radio
            >
            <vs-radio
              class="ml-3"
              v-model="EventData.StreamingClient"
              vs-value="Zoom"
              name="StreamingClient"
              >Zoom</vs-radio
            >
          </div>
        </div>
        <div class="vx-col sm:w-3/12 w-full mt-4">
          <label>Default Event Language</label>
          <div class="w-full mt-5">
            <div class="w-full mt-5">
              <v-select
                class="mt-4"
                :options="['Engilsh', 'German', 'French', 'Mandarin']"
                v-model="defaultLanguage"
              />
            </div>
            <!-- <vs-radio
              v-model="EventData.StreamingClient"
              vs-value="Web"
              name="StreamingClient"
              >Web</vs-radio
            >
            <vs-radio
              class="ml-3"
              v-model="EventData.StreamingClient"
              vs-value="Zoom"
              name="StreamingClient"
              >Zoom</vs-radio
            > -->
          </div>
        </div>

        <div class="vx-col md:w-1/1 w-full mt-8 position-relative">
          <label>Description</label>
          <div class="mail-tmplt-btns">
            <div class="tmplt-btn-wrap">
              <a
                class="right-off-radius"
                @click="showRawHtml = showRawHtml ? false : true"
                >{{ showRawHtml ? "Editor" : "HTML Code" }}</a
              >
            </div>
          </div>
          <div class="profile-edit">
            <quill-editor
              v-if="!showRawHtml"
              v-model="EventData.Description"
              class="desc-event"
            />
            <vs-textarea
              v-if="showRawHtml"
              v-model="EventData.Description"
              class="inputx w-full"
              rows="10"
              cols="100"
            />
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-3">
          <label>Event Type</label>
          <v-select
            class="w-full select-large"
            label="Name"
            v-model="EventData.LocationType"
            :options="locationOptions"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-3">
          <label>Default Landing Page</label>
          <v-select
            class="w-full select-large"
            v-model="EventData.DefaultLandingURL"
            :options="landingURLOptions"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 name-evnt mt-3 d-none">
          <vs-input
            v-show="EventData.LocationType.Name != 'Virtual'"
            class="w-full"
            label="Location"
            v-model="EventData.Venue"
          />
        </div>
        <!--
        <div class="vx-col w-full mt-4">
          <GmapMap
            :center="center"
            :zoom="7"
            map-type-id="terrain"
            style="width: 100%; height: 400px"
            @click="mapClicked"
          >
            <GmapMarker
              :key="index"
              v-for="(m, index) in markers"
              :position="m.position"
              :clickable="true"
              :draggable="true"
              @click="center=m.position"
            />
          </GmapMap>
        </div>
        -->
      </div>
    </tab-content>

    <!-- tab 2 content -->
    <tab-content
      title="Create Event: Success"
      class="mb-5 success-confetti"
      :before-change="continueEventEdit"
    >
      <div class="vx-row mb-5">
        <div class="text-center w-full success-class">
          <span><img src="../../assets/images/check-success.svg"/></span>
          <h2>Your event has been</h2>
          <h2 class="mb-3">successfully created!</h2>
          <h5>Select Design Theme, Event features and modules.</h5>
        </div>
      </div>
      <!-- <div class="vx-row mb-5">
        <div class="text-center w-full">
          <h2>Up Next!</h2>
        </div>
      </div>
      <div class="vx-row mb-5">
        <div class="text-center w-full">
          <h5>Select Design Theme, Event features and modules.</h5>
        </div>
        <vs-button type="gradient" @click="continueEventEdit">OK</vs-button>
      </div> -->
    </tab-content>
    <!--
    <vs-popup
      class="holamundo pop-up-wrap"
      title="Create Event: Success"
      :active.sync="popupActiveEvnetAddSuccess"
    >
      <div>Event created successfully.</div>
      <div>Please set the Event theme and Enable features you wish to use for this event to complete the setup.</div>
      <vs-button type="gradient" @click="continueEventEdit">OK</vs-button>
    </vs-popup>-->
    <!-- tab  content -->
  </form-wizard>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
//import moment from 'vue-moment'
import moment from "moment-timezone";
import draggable from "vuedraggable";
import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
import moduleClientManagement from "@/store/client-management/moduleClientManagement.js";

import ls from "@/common/localStorage";
let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id");
var vm;
export default {
  data() {
    return {
      popupActive: false,
      center: { lat: 10.0, lng: 10.0 },
      markers: [
        { position: { lat: 10.0, lng: 10.0 } },
        { position: { lat: 11.0, lng: 11.0 } },
      ],
      locationOptions: [
        { Id: 1, Name: "In-person" },
        { Id: 2, Name: "Virtual" },
        { Id: 3, Name: "Hybrid" },
      ],
      statusOptions: [
        { text: "Plannning", value: "plannning" },
        { text: "In Progress", value: "in progress" },
        { text: "Finished", value: "finished" },
      ],
      LocationOptions: [
        { text: "New York", value: "new-york" },
        { text: "Chicago", value: "chicago" },
        { text: "San Francisco", value: "san-francisco" },
        { text: "Boston", value: "boston" },
      ],
      landingURLOptions: [
        "/lobby",
        "/sessions",
        "/livestage",
        "/stageview",
        "/attendee",
        "/exhibitorshall",
        "/mymeetings",
        "/myprofile",
      ],

      list: [],
      showRawHtml: false,
      configdateTimePickerStart: {
        /*minDate: new Date(
          new Date().getFullYear() +
            "-" +
            new Date().getMonth() +
            "-" +
            new Date().getDate() +
            " 00:00"
        ),*/
        minDate: new Date().setHours(0, 0, 0, 0),
        onChange: function (val) {
          if (val) {
            vm.configdateTimePickerEnd.minDate = new Date(val);
          }
        },
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y H:i",
        defaultHour: 0,
        defaultMinute: 0,
        time_24hr: true,
      },
      configdateTimePickerEnd: {
        /*minDate: new Date(
          new Date().getFullYear() +
            "-" +
            new Date().getMonth() +
            "-" +
            new Date().getDate() +
            " 00:00"
        ),*/
        minDate: new Date().setHours(0, 0, 0, 0),
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y H:i",
        defaultHour: 0,
        defaultMinute: 0,
        time_24hr: true,
      },
      popupActiveEvnetAddSuccess: false,
      EventId: "",
      EventData: null,
      tzStrings: [
        { label: "(GMT-11:00) Midway Island, Samoa", value: "Pacific/Midway" },
        { label: "(GMT-10:00) Hawaii", value: "Pacific/Honolulu" },
        { label: "(GMT-09:00) Alaska", value: "America/Anchorage" },
        {
          label: "(GMT-08:00) Pacific Time (US & Canada)",
          value: "America/Los_Angeles",
        },
        {
          label: "(GMT-08:00) Tijuana, Baja California",
          value: "America/Tijuana",
        },
        { label: "(GMT-07:00) Arizona", value: "America/Phoenix" },
        {
          label: "(GMT-07:00) Mountain Time (US & Canada)",
          value: "America/Denver",
        },
        { label: "(GMT-06:00) Central America", value: "America/Managua" },
        {
          label: "(GMT-06:00) Central Time (US & Canada)",
          value: "America/Chicago",
        },
        {
          label: "(GMT-06:00) Guadalajara, Mexico City, Monterrey",
          value: "America/Mexico_City",
        },
        { label: "(GMT-06:00) Saskatchewan", value: "America/Regina" },
        {
          label: "(GMT-05:00) Bogota, Lima, Quito, Rio Branco",
          value: "America/Bogota",
        },
        {
          label: "(GMT-05:00) Eastern Time (US & Canada)",
          value: "America/New_York",
        },
        {
          label: "(GMT-04:00) Atlantic Time (Canada)",
          value: "Canada/Atlantic",
        },
        { label: "(GMT-04:00) Caracas, La Paz", value: "America/Caracas" },
        { label: "(GMT-04:00) Santiago", value: "America/Santiago" },
        { label: "(GMT-03:30) Newfoundland", value: "America/St_Johns" },
        { label: "(GMT-03:00) Brasilia", value: "America/Sao_Paulo" },
        {
          label: "(GMT-03:00) Buenos Aires, Georgetown",
          value: "America/Argentina/Buenos_Aires",
        },
        { label: "(GMT-03:00) Greenland", value: "America/Godthab" },
        { label: "(GMT-03:00) Montevideo", value: "America/Montevideo" },
        { label: "(GMT-01:00) Cape Verde Is.", value: "Atlantic/Cape_Verde" },
        { label: "(GMT-01:00) Azores", value: "Atlantic/Azores" },
        {
          label: "(GMT+00:00) Casablanca, Monrovia, Reykjavik",
          value: "Africa/Casablanca",
        },
        {
          label: "(GMT+00:00) Coordinated Universal Time",
          value: "UTC",
        },
        {
          label:
            "(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London",
          value: "Etc/Greenwich",
        },
        {
          label: "(GMT+00:00) Western Europe Time, London, Lisbon, Casablanca",
          value: "Europe/London",
        },
        {
          label: "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
          value: "Europe/Amsterdam",
        },
        {
          label:
            "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
          value: "Europe/Belgrade",
        },
        {
          label: "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris",
          value: "Europe/Brussels",
        },
        {
          label: "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
          value: "CET",
        },
        { label: "(GMT+02:00) Amman", value: "Asia/Amman" },
        {
          label: "(GMT+02:00) Athens, Bucharest, Istanbul",
          value: "Europe/Athens",
        },
        { label: "(GMT+02:00) Beirut", value: "Asia/Beirut" },
        { label: "(GMT+02:00) Cairo", value: "Africa/Cairo" },
        { label: "(GMT+02:00) Harare, Pretoria", value: "Africa/Harare" },
        {
          label: "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
          value: "Europe/Helsinki",
        },
        { label: "(GMT+02:00) Jerusalem", value: "Asia/Jerusalem" },
        { label: "(GMT+03:00) Kuwait, Riyadh, Baghdad", value: "Asia/Kuwait" },
        { label: "(GMT+03:00) Baghdad", value: "Asia/Baghdad" },
        {
          label: "(GMT+03:00) Moscow, St. Petersburg, Volgograd",
          value: "Europe/Moscow",
        },
        { label: "(GMT+03:00) Nairobi", value: "Africa/Nairobi" },
        { label: "(GMT+03:00) Tbilisi", value: "Asia/Baku" },
        { label: "(GMT+03:30) Tehran", value: "Asia/Tehran" },
        { label: "(GMT+04:00) Abu Dhabi, Muscat", value: "Asia/Muscat" },
        { label: "(GMT+04:00) Baku", value: "Asia/Baku" },
        { label: "(GMT+04:00) Yerevan", value: "Asia/Baku" },
        { label: "(GMT+04:30) Kabul", value: "Asia/Kabul" },
        { label: "(GMT+05:00) Yekaterinburg", value: "Asia/Yekaterinburg" },
        {
          label: "(GMT+05:00) Islamabad, Karachi, Tashkent",
          value: "Asia/Tashkent",
        },
        {
          label: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi",
          value: "Asia/Calcutta",
        },
        { label: "(GMT+06:00) Almaty, Novosibirsk", value: "Asia/Almaty" },
        { label: "(GMT+06:00) Astana, Dhaka", value: "Asia/Dhaka" },
        { label: "(GMT+07:00) Bangkok, Hanoi, Jakarta", value: "Asia/Bangkok" },
        { label: "(GMT+07:00) Krasnoyarsk", value: "Asia/Krasnoyarsk" },
        {
          label: "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
          value: "Asia/Hong_Kong",
        },
        { label: "(GMT+08:00) Kuala Lumpur", value: "Asia/Kuala_Lumpur" },
        { label: "(GMT+08:00) Singapore", value: "Asia/Singapore" },
        { label: "(GMT+08:00) Irkutsk, Ulaan Bataar", value: "Asia/Irkutsk" },
        { label: "(GMT+08:00) Perth", value: "Australia/Perth" },
        { label: "(GMT+08:00) Taipei", value: "Asia/Taipei" },
        { label: "(GMT+09:00) Osaka, Sapporo, Tokyo", value: "Asia/Tokyo" },
        { label: "(GMT+09:00) Seoul", value: "Asia/Seoul" },
        { label: "(GMT+09:00) Yakutsk", value: "Asia/Yakutsk" },
        { label: "(GMT+09:30) Adelaide", value: "Australia/Adelaide" },
        { label: "(GMT+09:30) Darwin", value: "Australia/Darwin" },
        { label: "(GMT+10:00) Brisbane", value: "Australia/Brisbane" },
        {
          label: "(GMT+10:00) Canberra, Melbourne, Sydney",
          value: "Australia/Sydney",
        },
        { label: "(GMT+10:00) Hobart", value: "Australia/Hobart" },
        { label: "(GMT+10:00) Guam, Port Moresby", value: "Pacific/Port_Moresby" },
        { label: "(GMT+10:00) Vladivostok", value: "Asia/Vladivostok" },
        {
          label: "(GMT+11:00) Magadan, Solomon Is., New Caledonia",
          value: "Asia/Magadan",
        },
        {
          label: "(GMT+12:00) Auckland, Wellington",
          value: "Pacific/Auckland",
        },
        {
          label: "(GMT+12:00) Fiji, Kamchatka, Marshall Is.",
          value: "Pacific/Fiji",
        }
      ],
      ClientDetails: null,
      defaultLanguage: "English",
    };
  },
  methods: {
    checkCRMDisable() {
      if (this.EventData.postToCRM === false) {
        this.$vs.dialog({
          type: "alert",
          color: "danger",
          title: "Are you Sure?",
          text: "This will stop sending Registration data to your CRM",
          acceptText: "OK",
        });
      }
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      debugger;
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    mapClicked() {},
    before_save() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          //resolve(result);
          if (result) {
            resolve(vm.formSubmitted());
          }
        });
      });
    },
    closeEventAddPopupSuccess: function () {
      this.popupActiveEvnetAddSuccess = false;
    },
    formSubmitted() {
      this.EventData.StartDateTZ = moment(this.EventData.EventStartDate).format(
        "MMM DD, YYYY"
      );
      this.EventData.StartTimeTZ = moment(this.EventData.EventStartDate).format(
        "HH:mm"
      );
      this.EventData.EndDateTZ = moment(this.EventData.EventEndDate).format(
        "MMM DD, YYYY"
      );
      this.EventData.EndTimeTZ = moment(this.EventData.EventEndDate).format(
        "HH:mm"
      );
      this.EventData.StartDate = this.GetTimeByZone(
        this.EventData.EventStartDate,
        this.EventData.TimeZone
      );
      this.EventData.EndDate = this.GetTimeByZone(
        this.EventData.EventEndDate,
        this.EventData.TimeZone
      );
      this.EventData.DefaultLanguage = this.defaultLanguage;
      this.$vs.loading();
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("eventManagement/addEvent", { data: this.EventData })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Event",
              text: res.message,
            });
            this.$vs.loading.close();
            if (res.status == 200) {
              //this.$router.push('/event/list');
              debugger;
              let info = {
                Session_Event_Id: res.data.EventId,
                Session_Event_CollectionName: res.data.EventCollectionName,
                Session_Event_FullName: res.data.EventFullName,
                Session_Event_TZ: res.data.TimeZone,
                Sesion_StreamingClient: res.data.StreamingClient,
                Default_Event_Language: res.data.DefaultLanguage,
              };
              ls.setSessionUserInfo(info);
              //this.$emit("closeEventAddPopup");
              //this.popupActiveEvnetAdd = false;
              //this.popupActiveEvnetAddSuccess = true;
              //location.href = "/event/edit";
              resolve(true);
            } else {
              debugger;
              resolve(false);
            }
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
            resolve(false);
          });
      });
      //this.popupActiveEvnetAddSuccess = true;
    },
    onComplete: function () {
      //alert("onComplete");
      //location.href = "/event/edit";
    },
    continueEventEdit() {
      //alert("continueEventEdit");
      location.href = "/event/edit";
    },
    fetch_event_data() {
      this.$store
        .dispatch("eventManagement/fetchEvent", null)
        .then((res) => {
          debugger;
          this.EventData = res.data;
          this.EventData.EventStartDate = new Date();
          this.EventData.EventEndDate = new Date().setDate(new Date().getDate() + 1);
        })
        .catch((err) => {});
    },
    fetchClient() {
      this.$store
        .dispatch("clientManagement/fetchClient", Session_Client_Id)
        .then((res) => {
          if (res.status == 200) {
            this.ClientDetails = res.data;
            this.EventData.postToCRM = this.ClientDetails.crm_integration
              .IsPublished
              ? true
              : false;
          }
        });
    },
  },
  components: {
    FormWizard,
    TabContent,
    Datepicker,
    flatPickr,
    draggable,
    vSelect,
    quillEditor,
  },

  mounted() {
    vm = this;
    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
    this.fetch_event_data();
    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
    this.fetchClient();
  },
  watch: {
    "EventData.EventType"(val) {
      debugger;
      if (val == 1) {
        this.EventData.AllowRegistration = false;
      }
    },
  },
};
</script>